function negotiateAttribute (name, model, element) {
	if (name in model)
		element[name] = model[name];
}

module.exports = negotiateAttribute;